import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import Focus from "../components/sections/Focus";
import Activities from "../components/sections/Activities";
import Impact from "../components/sections/Impact";
import { SpecialCta } from "../components/sections/CtaSections";

export default function OurWork() {
  return (
    <main>
      <Seo
        title="हमारे कार्य — शिक्षा, स्वास्थ्य, महिला सशक्तिकरण, पर्यावरण"
        description="Anansha Welfare Society Varanasi के कार्य क्षेत्र — शिक्षा, स्वास्थ्य सेवा, महिला सशक्तिकरण, बाल कल्याण, पर्यावरण एवं जल संरक्षण, कौशल विकास और समाज सेवा।"
        path="/our-work"
        breadcrumb={["हमारे कार्य"]}
      />
      <PageHero
        overline={{ hi: "कार्य क्षेत्र", en: "Our Work" }}
        title={{ hi: "हमारे कार्य", en: "Our Work" }}
        description={{
          hi: "शिक्षा, स्वास्थ्य, महिला सशक्तिकरण, पर्यावरण संरक्षण, जल संरक्षण, कौशल विकास और समाज सेवा — हर क्षेत्र में जमीनी स्तर पर कार्य।",
          en: "Education, healthcare, women empowerment, environment protection, water conservation, skill development and social service — grassroots work in every area.",
        }}
        testid="work-page-heading"
      />
      <Focus />
      <Activities />
      <Impact />
      <SpecialCta />
    </main>
  );
}
